module.exports = __webpack_public_path__ + "b0045e08e30fe24b4a5beffd60b58812.woff";